import {notificationPushTypes} from "../../actions/notification-push/types";

const initialState = {
    notificationCount: 0,
    notificationData: [],
    listInformation: []
};

const notificationPushReducer = (state = initialState, action) => {
    switch (action.type) {
        case notificationPushTypes.ADD_NOTIFICATION_COUNT:
            return {
                ...state,
                notificationCount: action.notificationCount,
            }
        case notificationPushTypes.ADD_NOTIFICATION_DATA:
            return {
                ...state,
                notificationData: action.notificationData,
            }
        case notificationPushTypes.ADD_USER_INFORMATION:
            return {
                ...state,
                listInformation: [...state.listInformation, action.userInformation]
            }
        case notificationPushTypes.ADD_OBJECT_INFORMATION:
            return {
                ...state,
                listInformation: [...state.listInformation, ...action.objectInformation]
            }
        default:
            return state;
    }
};

export default notificationPushReducer;